<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-text class=" pa-4 display-18">{{alertText}}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialog = false">סגור</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      alertText: 'כדי לשלוח קורות חיים למשרה זו יש לענות על דרישות החובה'
    }
  },

  mounted() {
    this.$bus.$on('showDialog', this.showDialog)
  },

  beforeDestroy() {
    this.$bus.$off('showDialog')
  },

  methods: {
    showDialog(text) {
      this.alertText = text
      this.dialog = !this.dialog
    }
  }
}
</script>
